import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroRomaneioClienteLista {
  lastSetDefault: Date;

  DZ00DATA_DE: Date | undefined;
  DZ00DATA_ATE: Date | undefined;
  CZ00COD: string;
  CZ00PLACA: string;
  CZ00CLIENT: string;
  CZ00STATUS: string;
  CZ00PROCES: string;
  CEE7PEDIDO: string;
}

export class FiltroRomaneioClienteLista {

  dados: IFiltroRomaneioClienteLista;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-lista-romaneio-cliente';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroRomaneioClienteLista) => {
      if (filtro) {

        const {
          lastSetDefault,
          DZ00DATA_DE,
          DZ00DATA_ATE
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
            DZ00DATA_DE: DZ00DATA_DE ? new Date(DZ00DATA_DE) : undefined,
            DZ00DATA_ATE: DZ00DATA_ATE ? new Date(DZ00DATA_ATE) : undefined,
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroRomaneioClienteLista => {
    return {
      lastSetDefault: new Date(),
      DZ00DATA_DE: this.getData(-7),
      DZ00DATA_ATE: new Date(),
      CZ00COD: '',
      CZ00PLACA: '',
      CZ00CLIENT: '',
      CZ00STATUS: '0',
      CZ00PROCES: '',
      CEE7PEDIDO: '',
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
